module.exports = __webpack_public_path__ + "static/media/door_three_key.7f815558.png";